import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @description Design: https://www.figma.com/design/WMwUaibi2LRURMHSKSxcj5/SSDK-Components?node-id=15-975&m=dev
 *
 * @param {Object} props
 * @param {import('utils/types').Size} [props.size] - Size of the tag
 * @param {"dark" | "light"} [props.mode] - Light vs Dark mode of the tag
 * @param {string} [props.className] - Additional class names to apply
 * @param {React.ReactNode} props.children - Content to display inside the tag
 */
export default function Tag({
  size = 'md',
  mode = 'light',
  className = '',
  children = null
}) {
  return (
    <div
      data-mode={mode}
      data-size={size}
      className={cn(styles.container, className)}
    >
      {children}
    </div>
  );
}
